import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { VoucherType } from 'src/features/voucherTypes/utils/types';
import { VoucherTypeFormSchemaValues } from 'src/features/voucherTypes/utils/formSchema';

const RESOURCE = '/discounts/voucher-type/:voucherTypeId/';

type MutationFnType = typeof mutationFn;

interface DTO extends VoucherTypeFormSchemaValues {
    voucherTypeId: string;
}
const mutationFn = ({ voucherTypeId, ...data }: DTO): Promise<VoucherType> => {
    return axios.put(formatResourcePath(RESOURCE, { voucherTypeId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateVoucherType };
